/*
 * SMA product card
 * ----------------
 * Two behaviours for `snippets/card-product.liquid`:
 *
 * 1. Colour swatches under the price. Clicking one marks it selected, swaps the
 *    card's main image for that variant's image (the image assigned to the
 *    variant in the Shopify admin), and repoints the card link + quick add.
 *
 * 2. The "Quick Add" button in the hover panel. It doesn't add to cart itself —
 *    it forwards the click to Dawn's own quick add control, which the card
 *    renders hidden inside `.sma-card__native-qa`. That keeps the standard
 *    popup / add-to-cart flow exactly as Shopify configured it.
 *
 * Delegated listeners, so cards injected later (AJAX filtering, product
 * recommendations) work without re-initialising.
 */
(function () {
  if (window.__smaCardInit) return;
  window.__smaCardInit = true;

  /* ---------------------------------------------------------------- swatches */

  function selectSwatch(button) {
    var card = button.closest('.card-wrapper');
    if (!card) return;

    var group = button.closest('[data-sma-swatches]');
    if (group) {
      group.querySelectorAll('.sma-card__swatch').forEach(function (swatch) {
        swatch.classList.toggle('is-selected', swatch === button);
      });
    }

    var src = button.getAttribute('data-img-src');
    var srcset = button.getAttribute('data-img-srcset');
    var media = card.querySelector('.card__media .media');

    if (media && src) {
      var images = media.querySelectorAll('img');
      var main = images[0];

      if (main) {
        /* Drop the secondary hover image — it belongs to the previous colour.
           It has to leave the DOM (not just be hidden) so the theme's
           `:only-child` hover rules keep working on the remaining image. */
        for (var i = 1; i < images.length; i++) images[i].remove();

        main.setAttribute('src', src);
        if (srcset) {
          main.setAttribute('srcset', srcset);
        } else {
          main.removeAttribute('srcset');
        }
      }
    }

    var url = button.getAttribute('data-variant-url');
    if (url) {
      card.querySelectorAll('a.full-unstyled-link, a.sma-card__media-link').forEach(function (link) {
        link.setAttribute('href', url);
      });
      /* So the quick add popup opens on the colour that's showing. */
      var opener = card.querySelector('.sma-card__native-qa [data-product-url]');
      if (opener) opener.setAttribute('data-product-url', url);
    }
  }

  /* -------------------------------------------------------------- quick add */

  function setLoading(button, on) {
    button.classList.toggle('loading', on);
    button.setAttribute('aria-disabled', on ? 'true' : 'false');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !on);
  }

  /* Mirror the hidden button's loading state back onto the visible one. */
  function followNativeState(proxy, native) {
    var started = Date.now();
    var timer = setInterval(function () {
      var busy = native.classList.contains('loading') || native.getAttribute('aria-disabled') === 'true';
      if ((!busy && Date.now() - started > 400) || Date.now() - started > 10000) {
        clearInterval(timer);
        setLoading(proxy, false);
      }
    }, 120);
  }

  function triggerQuickAdd(proxy) {
    var card = proxy.closest('.card-wrapper');
    if (!card) return;

    var native = card.querySelector('.sma-card__native-qa button[name="add"]');
    if (!native || native.disabled) return;

    /* If quick-add.js never loaded, <quick-add-modal> is an inert unknown element
       and clicking would silently do nothing. Send the shopper to the product
       page instead of leaving a dead button. */
    var opener = native.closest('modal-opener');
    if (opener) {
      var modal = document.querySelector(opener.getAttribute('data-modal'));
      if (!modal || typeof modal.show !== 'function') {
        var fallback = card.querySelector('a.sma-card__media-link, a.full-unstyled-link');
        window.location = native.getAttribute('data-product-url') || (fallback && fallback.href);
        return;
      }
    }

    setLoading(proxy, true);

    var form = native.form;
    if (native.type === 'submit' && form) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(native);
      } else {
        native.click();
      }
    } else {
      native.click();
    }

    followNativeState(proxy, native);
  }

  /* ---------------------------------------------------------------- wiring */

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;

      var swatch = event.target.closest('.sma-card__swatch');
      if (swatch) {
        event.preventDefault();
        event.stopPropagation();
        selectSwatch(swatch);
        return;
      }

      var proxy = event.target.closest('[data-sma-quick-add]');
      if (proxy) {
        event.preventDefault();
        event.stopPropagation();
        if (proxy.disabled || proxy.getAttribute('aria-disabled') === 'true') return;
        triggerQuickAdd(proxy);
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    if (!event.target.closest) return;
    var swatch = event.target.closest('.sma-card__swatch');
    if (!swatch) return;
    event.preventDefault();
    selectSwatch(swatch);
  });
})();